// mutations
const ADMIN_USERS_ALL = (state, adminUsers) => {
  if (adminUsers.code === 1) {
    state.adminUsers = adminUsers.data
    state.status = 'success'
  } else {
    alert(adminUsers.message)
    state.status = 'error'
  }
}

const ADMIN_USERS_FORM = (state, adminUsers) => {
  if (adminUsers.code === 1) {
    state.adminUsers = adminUsers.data
    state.status = 'success'
  } else {
    alert(adminUsers.message)
    state.status = 'error'
  }
}

const ADMIN_USERS_SHOW = (state, adminUsers) => {
  if (adminUsers.code === 1) {
    state.adminUsers = adminUsers.data
    state.status = 'success'
  } else {
    alert(adminUsers.message)
    state.status = 'error'
  }
}

const ADMIN_USERS_CREATE = (state, adminUsers) => {
  if (adminUsers.code === 1) {
    state.adminUsers = adminUsers.data
    state.status = 'success'
    alert(adminUsers.message)
  } else {
    alert(adminUsers.message)
    state.status = 'error'
  }
}

const ADMIN_USERS_UPDATE = (state, adminUsers) => {
  if (adminUsers.code === 1) {
    state.adminUsers = adminUsers.data
    state.status = 'success'
    alert(adminUsers.message)
  } else {
    alert(adminUsers.message)
    state.status = 'error'
  }
}

const ADMIN_USERS_DELETE = (state, adminUsers) => {
  if (adminUsers.code === 1) {
    state.adminUsers = adminUsers.data
    state.status = 'success'
    alert(adminUsers.message)
  } else {
    alert(adminUsers.message)
    state.status = 'error'
  }
}
const ADMIN_USERS_PROFILE_DATA = (state, adminUsers) => {
  if (adminUsers.code === 1) {
    state.adminUsers = adminUsers.data
    state.status = 'success'
  } else {
    alert(adminUsers.message)
    state.status = 'error'
  }
}
export default {
  ADMIN_USERS_ALL,
  ADMIN_USERS_FORM,
  ADMIN_USERS_SHOW,
  ADMIN_USERS_CREATE,
  ADMIN_USERS_UPDATE,
  ADMIN_USERS_DELETE,
  ADMIN_USERS_PROFILE_DATA
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/users/mutations.js